export const notificationsZh = {
  title: '通知中心',
  actions: {
    markAllRead: '全部标为已读',
    markRead: '标为已读',
  },
  status: {
    unread: '新',
  },
  empty: {
    title: '暂无通知',
    description: '暂时没有需要处理的通知',
  },
};

export type NotificationsTranslations = typeof notificationsZh;
